export const createUrlFront = (data) => {



    if (data.type) {
        return `?user=${data.type}`
    }
    else return ""; // window.location = '/'

}